var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 3,
    viewBox: "0 0 14 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 1.30103C-0.000976562 1.10211 0.078041 0.911348 0.218693 0.770696C0.359346 0.630043 0.550111 0.551025 0.749023 0.551025H13.249C13.4479 0.551025 13.6387 0.630043 13.7794 0.770696C13.92 0.911348 13.999 1.10211 13.999 1.30103C13.999 1.49994 13.92 1.6907 13.7794 1.83136C13.6387 1.97201 13.4479 2.05103 13.249 2.05103H0.749023C0.550111 2.05103 0.359346 1.97201 0.218693 1.83136C0.078041 1.6907 -0.000976562 1.49994 -0.000976562 1.30103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.5273fc60b4c1da68fa5d2ff3222059f3.svg";
export { ForwardRef as ReactComponent };